import { typedSupabase } from '@/lib/typed-supabase';

/**
 * User id from the local session.
 * `auth.getUser()` validates over the network and shares a lock with every
 * other caller. The sales portal fires several of those at once, so a miss
 * retries, the page unmounts into a skeleton, and the next mount starts again.
 */
export async function getCurrentUserId(): Promise<string | null> {
  const { data } = await typedSupabase.auth.getSession();
  return data.session?.user?.id ?? null;
}
